// extracted by mini-css-extract-plugin
module.exports = {"friendList":"FriendList_friendList__Wg8Io"};